const DESIGN_WIDTH = 1600
const DESIGN_HEIGHT = 900

export function getScreenScale(): number {
  return Math.min(window.innerWidth / DESIGN_WIDTH, window.innerHeight / DESIGN_HEIGHT)
}
